import { Maybe } from '@csp/csp-common-model';
import { BioSampleKitType, KitTypeAndDescription, KitTypeAndDescriptions } from '@csp/csp-common-hbs-model';

const from = (kitTypes: BioSampleKitType[], typeAndDescriptions: KitTypeAndDescription[]): KitTypeAndDescriptions => {
  const items = kitTypes.map(
    kitType =>
      typeAndDescriptions.find(kitAndDesc => kitAndDesc.kitType === kitType) ?? {
        kitType,
        kitDescription: undefined,
      },
  );

  const getDescriptionByType = (kitType: BioSampleKitType): Maybe<string> =>
    items.find(kitAndDesc => kitAndDesc.kitType === kitType)?.kitDescription;

  return {
    items,
    getDescriptionByType,
  };
};

export const KitTypeAndDescriptionsMapper = {
  from,
};
